import { render, staticRenderFns } from "./HotEditItem.vue?vue&type=template&id=34ed71a2&scoped=true&"
import script from "./HotEditItem.vue?vue&type=script&lang=js&"
export * from "./HotEditItem.vue?vue&type=script&lang=js&"
import style0 from "./HotEditItem.vue?vue&type=style&index=0&id=34ed71a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ed71a2",
  null
  
)

export default component.exports